type GtagFn = (
  command: 'event' | 'set',
  name: string,
  params?: Record<string, any>,
) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
  }
}

export function trackGaEvent(name: string, params?: Record<string, any>) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  if (process.env.REACT_APP_ENV === 'prod') {
    window.gtag('event', name, params ?? {});
  } else {
    console.log('GA_TRACK_EVENT', {
      name,
      params,
    });
  }
}

export function setGAUserProperties(
  props: Record<'partner_id' | 'source', any>,
) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  if (process.env.REACT_APP_ENV === 'prod') {
    window.gtag('set', 'user_properties', props);
  } else {
    console.log('GA_SET_USER_PROPERTIES', {
      user_properties: props,
    });
  }
}
